import React from 'react';
import Backend from '../../Layouts/Backend';
import Table from '../../UI/Table';
import { withTranslation } from 'react-i18next';

const TablePage = (props) => {
  const ctxMenuOptions = [
    {
      name: 'Edit',
      action: (row, rowIndex) => {},
    },
    { name: 'Delete' },
  ];
  const selectRow = {
    selected: [],
    onSelect: handleSelectRow,
    onSelectAll: handleSelectAllRow,
  };
  const handleSelectRow = (row) => {};
  const handleSelectAllRow = () => {};
  return (
    <Backend>
      <div className="content-inner">
        <Table
          columns={props.columns}
          data={props.data}
          ctxMenuOptions={ctxMenuOptions}
          selectRow={selectRow}
          hasPagination
        />
      </div>
    </Backend>
  );
};

export default withTranslation('app')(TablePage);
